import $$ from 'cmn-utils'

const baseUrl = "/api/safety/scheduler/";
export default {
    create: (params) => {
        return $$.post(baseUrl + 'create', params)
    },
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    get: (params) => {
        return $$.post(baseUrl + 'get', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    update: (params) => {
        return $$.post(baseUrl + 'update', params)
    },
}